@if (archive$ | async; as archive) {
  @if (search$ | async; as search) {
    <app-right-sidebar mode="archive" [gridApi]="gridApi">
      <app-archive-actions-toolbar
        #archiveActionsToolbar
        [actionMenu]="actionMenuComponent"
        [searchResults]="(results$ | async)!"
        [activeArchiveSearchResultCount]="resultCount"
        (refineSearch)="onRefineSearch()"
        (refreshSearch)="onRefreshSearch()"
        (editModeEnabledChange)="onToggleEdit($event)"
        (downloadSelectedRowsAsCsv)="onDownloadSelectedRowsAsCsv($event)"
        (openSelectedDocuments)="onOpenDocumentSelectedDocuments($event)"
      ></app-archive-actions-toolbar>
      <div class="full-width">
        @if (hasViewTabs$ | async) {
          <app-tab-view
            (activeTabChange)="onActiveTabChanged($event)"
          ></app-tab-view>
        }
        <ag-grid-angular
          #archiveGrid
          [ngStyle]="gridStyle"
          class="ag-theme-material"
          [gridOptions]="gridOptions"
        >
        </ag-grid-angular>
        <app-search-result-paginator
          [page]="currentPage"
          [result-count]="resultCount"
          (pageChange)="onPageChange($event)"
        ></app-search-result-paginator>
        @if (showTableFieldGrid) {
          <app-table-field-grid
            [archiveId]="archive.id"
            [editModeEnabled]="editModeEnabled"
          ></app-table-field-grid>
        }
      </div>
    </app-right-sidebar>
  } @else {
    @if (noDefaultSearch) {
      <app-dashboard></app-dashboard>
    }
  }
}

<app-archive-actions-menu
  #actionMenuComponent
  (openSelectedDocuments)="onOpenDocumentSelectedDocuments($event)"
  (downloadSelectedRowsAsCsv)="onDownloadSelectedRowsAsCsv($event)"
  (refreshSearch)="onRefreshSearch()"
></app-archive-actions-menu>
